// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__cx7D1","item":"Breadcrumbs_item__4fe0F","link":"Breadcrumbs_link__RtNrd"};